<template>
  <div>
    <van-tabs v-model:active="reserveDateNameActive" @change="tabsChange">
      <van-tab title-class="tabs-tab">
        <template #title>
          <van-tag type="primary">今日</van-tag>
        </template>
      </van-tab>
      <van-tab v-for="item in todayBedsideBookHomeBos" :key="item.id">
        <template #title>
          <span :customId="item.id">{{ item.mealTypeName }}</span>
        </template>
      </van-tab>
      <van-tab disabled>
        <template #title>
          <van-tag type="primary">明日</van-tag>
        </template>
      </van-tab>
      <van-tab v-for="item in tomorrowBedsideBookHomeBos" :key="item.id">
        <template #title>
          <span :customId="item.id">{{ item.mealTypeName }}</span>
        </template>
      </van-tab>
    </van-tabs>
    <div style="text-align: center; padding: 10px 0" v-if="!reserveStatus">
      <p>该餐次已结束预定</p>
      <p style="color: #999">
        {{ tabsObj.reserveEndtDate }}
        {{ tabsObj.reserveEndTime }}之前可预定{{
          tabsObj.reserveDateName + tabsObj.mealTypeName
        }}
      </p>
    </div>
    <van-tree-select
      v-model:active-id="activeId"
      v-model:main-active-index="activeIndex"
      height="94vh"
      :items="mealList"
      @click-nav="rightClick"
    >
      <template #content>
        <van-index-bar
          :index-list="indexList"
          index="主食"
          @change="indexBarChange"
        >
          <van-row
            v-for="item in mealList"
            :key="item.id"
            align="center"
            style="padding: 10px"
          >
            <van-index-anchor
              style="width: 100%; background: #f7f8fa"
              :id="item.name"
              :index="item.name"
            ></van-index-anchor>
            <!-- <van-row
              style="
                padding: 15px;
                background: #f7f8fa;
                color: #999;
                width: 100%;
              "
            >
              {{ item.name }}
            </van-row> -->
            <van-row
              v-for="meal in item.businessDishes"
              :key="meal.id"
              align="center"
              style="padding: 10px; width: 100%"
            >
              <van-col span="4" @click="toMealsDetails(meal)">
                <van-image :src="meal.headUrl" />
              </van-col>
              <van-col
                span="14"
                style="padding-left: 10px"
                @click="toMealsDetails(meal)"
              >
                <p style="padding: 5px 0">{{ meal.name }}</p>
                <p style="padding: 5px 0">
                  <span style="color: #1e98d7"> ￥{{ meal.price }} </span>
                  <span style="color: #999">/{{ meal.unitName }}</span>
                </p>
              </van-col>
              <van-col span="6">
                <van-stepper
                  v-if="reserveStatus"
                  @change="stepperChange(meal)"
                  v-model="meal.quantity"
                  input-width="20"
                  theme="round"
                  button-size="15"
                  disable-input
                  :default-value="0"
                  :min="0"
                />
              </van-col>
            </van-row>
          </van-row>
        </van-index-bar>
      </template>
    </van-tree-select>
    <!-- 购物车bar -->
    <ShoppingCart
      v-if="reserveStatus"
      @cartEmpty="cartEmpty"
      :shoppingData="shoppingData"
    ></ShoppingCart>
  </div>
</template>
<script setup>
import { bedsideBook, reserveList } from "@/api/orderingFood/orderingFood";
import { reactive, toRefs, computed } from "vue";
import { arrGoAgain } from "@/utils/common";
import { useRoute, useRouter } from "vue-router";
import ShoppingCart from "@/components/orderingFood/shoppingCart.vue";
import { setStorage, getStorage } from "@/utils/common";
const route = useRoute();
const router = useRouter();
const state = reactive({
  canteenId: route.query.canteenId,
  mealList: [],
  activeId: null,
  activeIndex: 0,
  mealObj: {},
  shoppingData: {
    selectList: [],
    shoppingCarNum: 0,
    mealTypeName: "",
    mealType: "",
    orgId: route.query.orgId,
    canteenId: route.query.canteenId,
    orgAddress: route.query.orgAddress,
    orderType: 3,
  },
  indexList: [],
  todayBedsideBookHomeBos: [],
  tomorrowBedsideBookHomeBos: [],
  reserveDateNameActive: 1,
  reserveStatus: true,
  tabsObj: {},
});

// 修改浏览器title
window.document.title = `今日${route.query.orderMeal}`;
const {
  tabsObj,
  tomorrowBedsideBookHomeBos,
  mealList,
  activeId,
  activeIndex,
  mealObj,
  testNum,
  selectList,
  shoppingCarNum,
  shoppingData,
  indexList,
  todayBedsideBookHomeBos,
  reserveDateNameActive,
  reserveStatus,
} = toRefs(state);
// 初始化数据
setStorage("shoppingData", JSON.stringify(state.shoppingData));
const queryMealList = () => {
  bedsideBook({ canteenId: state.canteenId }).then((v) => {
    const { data } = v;
    const indexList = [];
    data.businessDishTypes.forEach((value) => {
      indexList.push(value.name);
      value.businessDishes.forEach((food) => {
        food.text = food.name;
      });
      value.text = value.name;
      value.children = value.businessDishes;
    });
    state.mealList = data.businessDishTypes;
    state.mealObj = data.businessDishTypes[0];
    state.indexList = indexList;
    console.log(data);
    state.tabsObj = data.todayBedsideBookHomeBos[0];
    state.shoppingData.mealTypeName =
      data.todayBedsideBookHomeBos[0].mealTypeName;
    state.shoppingData.mealType = data.todayBedsideBookHomeBos[0].mealType;
    state.todayBedsideBookHomeBos = data.todayBedsideBookHomeBos;
    state.tomorrowBedsideBookHomeBos = data.tomorrowBedsideBookHomeBos;
    state.shoppingData.mealTypeName =
      data.todayBedsideBookHomeBos[0].mealTypeName;
    state.shoppingData.mealTypeName = data.todayBedsideBookHomeBos[0].mealType;
    state.reserveStatus = data.todayBedsideBookHomeBos[0].reserveStatus;
    state.reserveDate = data.todayBedsideBookHomeBos[0].reserveDate;
  });
};
queryMealList();

// tabs切换
const tabsChange = (val, value) => {
  const tabsList = [
    ...state.todayBedsideBookHomeBos,
    ...state.tomorrowBedsideBookHomeBos,
  ];
  console.log(val);
  let tabsObj = {};
  console.log(tabsList);
  switch (val) {
    case 1:
      tabsObj = tabsList[0];
      break;
    case 2:
      tabsObj = tabsList[1];
      break;
    case 3:
      tabsObj = tabsList[2];
      break;
    case 5:
      tabsObj = tabsList[3];
      break;
    case 6:
      tabsObj = tabsList[4];
      break;
    case 7:
      tabsObj = tabsList[5];
      break;
  }
  console.log(tabsObj);
  state.reserveStatus = tabsObj.reserveStatus;
  state.tabsObj = tabsObj;
  state.shoppingData.mealTypeName = tabsObj.mealTypeName;
  state.shoppingData.mealType = tabsObj.mealType;
  state.shoppingData.reserveDate = tabsObj.reserveDate;
  const params = {
    canteenId: state.canteenId,
    mealType: tabsObj.mealType,
    reserveDate: tabsObj.reserveDate,
  };
  reserveList(params).then((v) => {
    const { data } = v;
    const indexList = [];
    data.forEach((value) => {
      indexList.push(value.name);
      value.businessDishes.forEach((food) => {
        food.text = food.name;
      });
      value.text = value.name;
      value.children = value.businessDishes;
    });
    state.indexList = indexList;
    console.log(data);
    state.mealList = data;
  });
};
// 点击右侧
const rightClick = (val) => {
  const mealObj = state.mealList.filter((item, index) => {
    return index == val;
  })[0];
  state.mealObj = mealObj;
  const element = document.getElementById(mealObj.name);
  if (element) {
    console.log(element);
    element.scrollIntoView({ behavior: "smooth" });
  }
  console.log(element);
  // window.location.href = `#${mealObj.name}`;
};
// 加减号
const stepperChange = (val) => {
  if (val.quantity > 0) {
    state.shoppingData.selectList.push(val);
  } else {
    console.log(val.quantity);
    state.shoppingData.selectList.forEach((value, index) => {
      if (value.id == val.id) {
        state.shoppingData.selectList.splice(index, 1);
      }
    });
  }
  state.shoppingData.selectList = arrGoAgain(state.shoppingData.selectList);
  setStorage("shoppingData", JSON.stringify(state.shoppingData));
};
// 购物车数量
state.shoppingData.shoppingCarNum = computed(() => {
  let cartNum = 0;
  state.shoppingData.selectList.forEach((value) => {
    cartNum += value.quantity;
  });
  return cartNum;
});
// 购物车清空
const cartEmpty = () => {
  state.mealList.forEach((value) => {
    value.businessDishes.forEach((food) => {
      food.quantity = 0;
    });
  });

  console.log(132132);
};
const indexBarChange = (val) => {
  state.mealList.forEach((value, index) => {
    if (value.name == val) {
      state.activeIndex = index;
    }
  });
};
const toMealsDetails = (item) => {
  console.log(132123);
  router.push({ name: "mealsDetails", query: { id: item.id } });
};
</script>
<style lang="scss" scoped>
.van-icon-shopping-cart {
  font-size: 40px;
}
::v-deep .van-submit-bar__text {
  text-align: left;
  padding-left: 15px;
  span {
    color: #1e98d7;
  }
}
::v-deep .van-index-bar__sidebar {
  display: none;
}
::v-deep .tabs-tab {
  pointer-events: none;
}
</style>
